import { render, staticRenderFns } from "./UploadView.vue?vue&type=template&id=2a547772&scoped=true"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"
import style0 from "./UploadView.vue?vue&type=style&index=0&id=2a547772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a547772",
  null
  
)

export default component.exports